module.exports = __webpack_public_path__ + "img/videocall_black.13caa229.svg";